import * as SVG from './svg'

const YxCountry = {
  flag: (country: string) => {
    return SVG[country as keyof typeof SVG]
  }
}

export default YxCountry;